import React from 'react';
import CoreComponent from "../../../../Core/CoreComponent";
import Theme from '../../../../Themes/ThemeArtLexie'
import Style from './Styles/ProductsStyle'
import Settings from '../../Settings/Settings';
import Appbar from '../Appbar/Appbar';
import Product from './Subcomponents/Product';
import Grid from '@mui/material/Grid';
import SearchProducts from './Subcomponents/SearchProducts';
import Pagination from '../../../../CommonComponents/Pagination/PaginationComponent';
import LoadingComponent from '../LoadingComponent/LoadingComponent';
export default class Products extends CoreComponent {

    constructor(props) {
        super(props);
        this.loadComponentsProps()
        this.basicComponentConstants = {
            language: props.componentMethods.getManagerState().language,
            urlParams: props.componentConstants.urlParams
        }
    }

    componentDidMount() {
        super.componentDidMount()
        this.getProductsAction()
    }
    
    getProductsAction() {
        const that = this;
        let query = []
        if (this.props.componentConstants.urlParams.query) {
            query.push('q=' + this.props.componentConstants.urlParams.query)
        }
        if (this.props.componentConstants.urlParams.page) {
            query.push('page=' + this.props.componentConstants.urlParams.page)
        }
        that.props.componentMethods.setManagerState({loadingProducts: true, products: []},() => {
            that.ajax(Settings.API_URL + Settings.API_ENDPOINT_PRODUCTS + '?' + query.join('&'),{},'GET','products', (data) => {
                that.props.componentMethods.setManagerState({products: data.items, loadingProducts: false, currentPagination: data.pagination})
            }) 
        })
    }

    getSearchProductsAction(endpoint) {
        const that = this;
        that.props.componentMethods.setManagerState({loadingProducts: true, products: []},() => {
            that.ajax(Settings.API_URL + endpoint,{},'GET','products', (data) => {
                that.props.componentMethods.setManagerState({products: data.items, loadingProducts: false, currentPagination: data.pagination})
            }) 
        })
    }
    changePage(page) {
        let endpoint = Settings.API_ENDPOINT_PRODUCTS
        let query = []
        if (this.props.componentConstants.urlParams.query) {
            query.push('q=' + this.props.componentConstants.urlParams.query)
        }
        if (this.props.componentConstants.urlParams.page) {
            query.push('page=' + this.props.componentConstants.urlParams.page)
        }
        endpoint += + '?' + query.join('&')
        this.getSearchProductsAction(endpoint)
    }

    loadComponentsProps() {
        const that = this
        this.setComponentsConstants('Appbar', {
            ...this.basicComponentConstants
        }).setComponentsMethods('Appbar', {
            setManagerState: (object, callback) => {
                that.props.componentMethods.setManagerState(object, callback)
            },
            refreshMainComponent: () => {
                that.refresh()
            },
            getManagerState: () => {
                return that.props.componentMethods.getManagerState()
            },
            changeRoute: (route) => {
                that.props.componentMethods.changeRoute(route)
            },
            getLocalStorage: (storageName) => {
                return that.getLocalStorage(storageName)
            },
            clearErrorMessage: (index) => {
                that.props.componentMethods.clearErrorMessage(index)
            },
            getSearchProductsAction: (endpoint) => {
                that.getSearchProductsAction(endpoint)
            },
            changePage: (page) => {
                let paginationPattern = window.location.href.replace(/page\/[0-9]+[\/]{0,1}/i,'') 
                if(paginationPattern[paginationPattern.length - 1] === '/') {
                    paginationPattern = '' 
                } else {
                    paginationPattern = '/' 
                }
                that.props.componentMethods.changeRoute(window.location.pathname.replace(/page\/[0-9]+[\/]{0,1}/i,'') + paginationPattern + 'page/' + page)
            },
            ajax: (url, 
                dataObject = {}, 
                method, stateValue = '', 
                callback = () => {}, 
                headers = {}, 
                setState = true, 
                catchCallback = () => {}) => {
                    that.ajax (url, 
                        dataObject, 
                        method, stateValue, 
                        callback, 
                        headers, 
                        setState, 
                        catchCallback);
                },
        })
    }

    getRender() {
        const classes = Style();
        this.loadComponentsProps()

        let paginationPattern = window.location.pathname.replace(/page\/[0-9]+[\/]{0,1}/i,'') 
        if(paginationPattern[paginationPattern.length - 1] === '/') {
            paginationPattern += 'page/{{page}}' 
        } else {
            paginationPattern += '/page/{{page}}' 
        }

        return <div style={classes.root}>
                    <Appbar {...this.buildComponentProps('Appbar')} />
                    <div style={classes.pageContainer}>
                        <Grid container spacing={2}>
                        <SearchProducts {...this.buildComponentProps('Appbar')} />
                        {
                            this.props.componentMethods.getManagerState().loadingProducts ?
                            <LoadingComponent />
                            :
                            null
                        }
                        {
                            this.props.componentMethods.getManagerState().products.map((item, index)=> {
                                return <Grid item xs={12} md={4} lg={3} key={index}>
                                                <Product product={item} key={index} {...this.buildComponentProps('Appbar')} />
                                            </Grid>
                            })
                        }
                        </Grid>
                    </div>
                    <Pagination  {...this.buildComponentProps('Appbar')} pattern={paginationPattern} pagination={this.props.componentMethods.getManagerState().currentPagination} />
                </div>
    }
}
